var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('default-bar'),_c('default-drawer'),_c('default-view'),_c('default-footer'),_c('default-settings')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }